import React from 'react';
import { services } from '../utils/mockData';
import { ClipboardCheck, Mountain, Ruler, Plane, HardHat, Cable, Scan } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from './ui/card';

const iconMap = {
  ClipboardCheck: ClipboardCheck,
  Mountain: Mountain,
  Ruler: Ruler,
  Plane: Plane,
  HardHat: HardHat,
  Cable: Cable,
  Scan: Scan
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-50 text-blue-900 rounded-full text-sm font-semibold mb-4">
            Our Services
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Professional Surveying Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive land surveying services tailored to meet the needs of construction and development projects
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            // Center the last item if it's alone in the row
            const isLastItemAlone = index === services.length - 1 && services.length % 3 === 1;
            return (
              <Card
                key={service.id}
                className={`group hover:shadow-2xl transition-all duration-300 border-0 bg-white hover:-translate-y-2 cursor-pointer ${
                  isLastItemAlone ? 'lg:col-start-2' : ''
                }`}
              >
                <CardHeader className="text-center p-8">
                  <div className="mb-6 flex justify-center">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-700 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                      <IconComponent className="w-8 h-8 text-white" />
                    </div>
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-900 transition-colors">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
